// External Dependencies:
import React from 'react'
import Calendar from 'react-calendar/dist/entry.nostyle'

class FormCalendar extends React.Component {
	constructor( props ) {
		super( props )
	}

	static defaultProps = {

	}

	componentDidMount() {
		const { value } = this.props

		// Ensure an initial date is set and sent through,
		// allowing the user to continue without selecting a date (default to today).
		if ( value ) {
			this.handleChange( value )
		} else {
			this.handleChange( new Date() )
		}
	}

	handleChange = ( value ) => {
		// Ensure the date value is within the day:
		value.setHours( 12 )

		this.props.onChange( this.props.id, value )
	}

	render() {
		let { id, value, maxDate } = this.props
		let className = 'form-item form-calendar'

		if ( ! maxDate ) {
			maxDate = null
		}

		return (
			<div className={ className }>
				<Calendar
					onChange={ this.handleChange }
					value={ value }
					calendarType="US"
					maxDate={ maxDate }
				/>
			</div>
		)
	}
}

export default FormCalendar
